import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './App.css';
import { ContentWidget, FooterWidget, HeaderWidget } from './widgets';
const App = () => {
    return (_jsxs("div", { className: "page", children: [_jsx(HeaderWidget, {}), _jsx(ContentWidget, {}), _jsx(FooterWidget, {})] }));
};
export default App;
